export default __webpack_public_path__ + "static/media/chromium.5baa4edc.jpg";